import { FC, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import ReactModal from 'react-modal';
import classNames from 'classnames';
import qrIcon from './qrcode.svg';
import SvgIcon from '../SvgIcon/SvgIcon';
import Tooltip from '../Tooltip/Tooltip';
import QRModal from '../QRModal/QRModal';

import styles from './QRButton.module.scss';

const messages = defineMessages({
	showQR: {
		id: 'payments.show_qr',
		defaultMessage: 'Show QR code',
	},
});

type Props = {
	className?: string;
	label: string;
	data: string;
	displayValue?: string;
};

const QRButton: FC<Props> = ({ className, data, displayValue, label }) => {
	const [isOpen, setIsOpen] = useState(false);
	const { formatMessage } = useIntl();

	return (
		<div className={classNames(styles.container, styles.flex, className)}>
			<Tooltip content={formatMessage(messages.showQR)}>
				<div onClick={() => setIsOpen(true)} className={styles.flex}>
					<SvgIcon className={classNames(styles.icon, styles.flex)} src={qrIcon} />
				</div>
			</Tooltip>
			<ReactModal
				className={styles.modal}
				isOpen={isOpen}
				shouldCloseOnOverlayClick
				onRequestClose={() => setIsOpen(false)}
				style={{
					overlay: {
						backgroundColor: '#343E551E',
					},
				}}
			>
				<QRModal
					onClose={() => setIsOpen(false)}
					rawData={data}
					displayData={displayValue || data}
					label={label}
				/>
			</ReactModal>
		</div>
	);
};

export default QRButton;
